<div class="mini-grid">
  <div class="mini-grid_title">Sync Settings</div>
  <div class="sync-settings">



    <div class="d-flex align-items-center">
      <div class="input-container">
        <input type="number" [formControl]="maxSyncQty" placeholder="Max Qty" class="input-container_input input-container_input--extra-thin">
      </div>
      <div *ngIf="maxSyncQty.value !== null" class="clear_btn ms-2" (click)="removeInventory()">
        <i class="fal fa-times-circle"></i>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div class="error me-2">
        <span [matTooltip]="'Storefront sync is disabled. Inventory updates will not be synced'"
          matTooltipClass="error-tooltip" class="box_title--alert" *ngIf="!sku.channelSync && sku.skuStockEnabled">
          <i class="fal fa-exclamation-triangle"></i>
        </span>
      </div>
      <div class="input-container  input-container--sync">
        <label for="" class="input-container_label mb-0">
            <mat-slide-toggle [(ngModel)]="isSyncEnabled" (change)="change($event)">Sync Inventory</mat-slide-toggle>
        </label>
      </div>
    </div>

  </div>
  <div class="ag-theme-alpine-po-detail">
    <ag-grid-angular
    style="width: 100%; height: 475px;"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"
      [rowData]="syncHistory"
      [modules]="modules"
      [rowHeight]="30"
      [headerHeight]="30"
    >
    </ag-grid-angular>
  </div>
</div>
